import { theme } from '@features/lci-report/domain/theme';
import { PositionProps, TextProps } from '@features/powerpoint';
import { SlideSection } from '../domain/content';

export const column = (
  section: SlideSection,
  positionProps: PositionProps
): TextProps => {
  const { items } = section;
  if (items.text.length === 0) return { text: [], options: {} };

  return {
    text: [
      {
        text: section.label,
        options: { fontSize: theme.fontSizes.h3, breakLine: true },
      },
      ...(typeof items.text === 'string' ? [{ text: items.text }] : items.text),
    ],
    options: {
      ...items.options,
      color: theme.colors.white,
      fontSize: 7,
      valign: 'top',
      paraSpaceAfter: 5,
      ...positionProps,
    },
  };
};
